// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
  production: false,
  authorizedUrls: {
      authUrl: 'http://localhost:8080/auth',
      spTransUrl: 'http://localhost:8080/sptrans',
      intercambiosUrl: 'http://localhost:8080/intercambios',
      faturamentoUrl: 'http://localhost:8080/faturamento',
      multiplasUrl: 'http://localhost:8080/multiplas',
      bsCobrancaUrl: 'https://cobranca-service.fastedi.com.br/bscobranca-service/api',
      // bsCobrancaUrl: 'http://localhost:8080/bscobranca-service/api',
  }
};
